/* born-v11.js — "Build your display": hardware + display creative in one add-to-cart.

   Design notes, because the obvious approaches are all worse:
   - Shopify's product form posts ONE variant id, so a second line item cannot be
     expressed in the markup. /cart/add.js accepts an `items:[]` array, so the two
     lines go up in a single round trip and the cart can never end up half-built.
   - Dawn's <product-form> binds its own submit listener on the form (target phase).
     A capture-phase listener on `document` runs BEFORE that, so stopPropagation()
     there cleanly pre-empts Dawn without patching or replacing any of its code.
   - We only intercept when a paid package is actually selected. Hardware-only
     add-to-cart falls straight through to Dawn untouched — no behaviour change, and
     no risk to the 265 products that never show this picker.
*/
(function () {
  'use strict';

  var MONEY = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  function money(cents) { return MONEY.format((cents || 0) / 100); }

  function picker() { return document.querySelector('[data-bn-creative][data-context="product"]'); }

  function chosen() {
    var p = picker();
    if (!p) return null;
    var input = p.querySelector('input[name="bn-creative-pkg"]:checked');
    if (!input || !input.value) return null;
    return { id: input.value, price: parseInt(input.dataset.price, 10) || 0, title: input.dataset.title || 'Display Creative' };
  }

  /* Running total, so the customer sees the real number before committing. */
  function syncTotal() {
    var p = picker(); if (!p) return;
    var out = p.querySelector('[data-bn-creative-total]'); if (!out) return;
    var pick = chosen();
    if (!pick) { out.hidden = true; out.textContent = ''; return; }

    var hw = 0;
    var priceEl = document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');
    if (priceEl) {
      var digits = priceEl.textContent.replace(/[^0-9.]/g, '');
      if (digits) hw = Math.round(parseFloat(digits) * 100);
    }
    out.hidden = false;

    /* The custom route is a real $0 line so the order records it, but printing
       "+ $0.00" reads as cheap rather than bespoke. Say what actually happens. */
    if (!pick.price) {
      out.innerHTML = hw
        ? 'Hardware <strong>' + money(hw) + '</strong> — your custom creative scope is priced with you, so it adds nothing here.'
        : 'Your custom creative scope is priced with you, so it adds nothing to this order.';
      return;
    }

    out.innerHTML = hw
      ? 'Hardware ' + money(hw) + ' + ' + pick.title + ' ' + money(pick.price) +
        ' <strong>= ' + money(hw + pick.price) + '</strong>'
      : pick.title + ' ' + money(pick.price) + ' will be added to your order.';
  }

  function bindPicker() {
    var p = picker(); if (!p || p.dataset.bnBound) return;
    p.dataset.bnBound = '1';
    p.addEventListener('change', syncTotal);
    syncTotal();
  }

  /* Dawn re-renders the product info block on variant change, which can replace the
     price node the total reads from. Re-sync on any variant change. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name && /^options\[/.test(e.target.name)) setTimeout(syncTotal, 60);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    var pick = chosen();
    if (!pick) return;                       // hardware only — let Dawn handle it

    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return;  // nothing to pair with; stay out of the way

    e.preventDefault();
    e.stopPropagation();

    var qtyField = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
    /* `.product__title` is a WRAPPER around the h1, and a comma selector returns the
       first match in document order — the wrapper — whose textContent contains the
       title twice plus the whitespace between. That shipped a cart property reading
       "WaveLight… 10ft\n\n  WaveLight… 10ft". Ask for the heading itself first, and
       collapse whitespace either way. */
    var titleEl = document.querySelector('.product__title h1')
      || document.querySelector('h1.product__title')
      || document.querySelector('.product__title');
    var hwTitle = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : 'your display';

    var btn = form.querySelector('[name="add"]');
    var btnText = btn ? btn.querySelector('span') : null;
    var restore = btnText ? btnText.textContent : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (btnText) btnText.textContent = 'Adding…';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        /* Creative FIRST, hardware second. Shopify puts the most recently added line
           at the TOP of the cart, so sending hardware first pushed the graphics line
           above it — the add-on reading before the thing it belongs to. Reversing the
           array puts the display on top and its graphics underneath, which is the
           order the cart should tell the story in.
           The hardware line's property is labelled "Graphics" rather than repeating
           the product name, which rendered as "Display Creative: Display Creative". */
        items: [
          { id: pick.id, quantity: qty, properties: { For: hwTitle, _bn_pair: String(idField.value) } },
          { id: idField.value, quantity: qty, properties: { Graphics: pick.title } }
        ]
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Add to cart failed');
        /* Straight to the cart: it is the one place that shows hardware and graphics
           as separate priced lines, which is the whole point of the feature. */
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root : '/') + 'cart';
      })
      .catch(function (err) {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        if (btnText) btnText.textContent = restore;
        var out = picker() && picker().querySelector('[data-bn-creative-total]');
        if (out) { out.hidden = false; out.textContent = 'Could not add that just now — please try again, or call 719-247-1189.'; }
        if (window.console) console.error('[born] add-to-cart', err);
      });
  }, true); /* capture: runs before Dawn's own submit handler */

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindPicker);
  else bindPicker();
  document.addEventListener('shopify:section:load', bindPicker);
})();

/* --- Cursor-following image peek, generalised -------------------------------
   born-v3.js gives the "In the box" table an image that tracks the cursor while a
   row is hovered. That behaviour is hardcoded to `.bn-table--hover` /
   `.bn-table__row`, so this binds the same interaction to any
   `[data-bn-peek]` container whose children carry `data-peek`, and reuses the
   existing `.bn-table__peek` element and its born-v3.css styling — same easing,
   same 300x400 card, same fade. No new visual language, and born-v3 is untouched. */
(function () {
  'use strict';
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function initPeek() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    each(document.querySelectorAll('[data-bn-peek]'), function (host) {
      if (host.dataset.bnPeekBound) return;
      host.dataset.bnPeekBound = '1';

      var targets = host.querySelectorAll('[data-peek]');
      if (!targets.length) return;

      var peek = document.createElement('div');
      peek.className = 'bn-table__peek';
      peek.setAttribute('aria-hidden', 'true');
      document.body.appendChild(peek);

      var imgs = {}, tx = 0, ty = 0, cx = 0, cy = 0, running = false, active = null;

      function frame() {
        cx += (tx - cx) * 0.16;
        cy += (ty - cy) * 0.16;
        peek.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0) translate(-50%,-50%) scale(' + (active ? 1 : 0.9) + ')';
        if (Math.abs(tx - cx) > 0.3 || Math.abs(ty - cy) > 0.3 || active) requestAnimationFrame(frame);
        else running = false;
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }

      each(targets, function (el) {
        var src = el.getAttribute('data-peek');
        if (!src) return;
        el.addEventListener('pointerenter', function (e) {
          active = el;
          el.classList.add('is-hot');
          var img = imgs[src];
          if (!img) { img = document.createElement('img'); img.alt = ''; img.src = src; imgs[src] = img; peek.appendChild(img); }
          each(peek.querySelectorAll('img'), function (i) { i.classList.toggle('is-on', i === img); });
          tx = e.clientX; ty = e.clientY;
          if (cx === 0 && cy === 0) { cx = tx; cy = ty; }
          peek.classList.add('is-on');
          kick();
        });
        el.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; kick(); });
        el.addEventListener('pointerleave', function () {
          el.classList.remove('is-hot');
          if (active === el) { active = null; peek.classList.remove('is-on'); }
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPeek);
  else initPeek();
  document.addEventListener('shopify:section:load', initPeek);
})();
